<template>
    <div :class="['info-block', modify]">
        <div class="info-block__status">
            <div v-if="type === 1"
                 class="info-block__icon">
                <IconInfo class-name="icon-stroke icon_color_blue" />
            </div>
            <div v-else-if="type === 2"
                 class="info-block__icon info-block_color_gray">
                <IconCloseSmall class-name="icon-stroke icon_color_gray" />
            </div>
            <div v-else-if="type === 3"
                 class="info-block__icon">
                <IconCheckStatus class-name="icon-stroke icon_color_blue" />
            </div>
            <div :class="['info-block__title', { 'black-color': type === 2}]"
                 v-html="title" />
        </div>
        <div class="info-block__description"
             v-html="description" />
        <slot />
        <div v-if="link && link.length"
             class="info-block__buttons">
            <div class="info-block__button">
                <STBaseButton :text="linkText"
                              icon-before="IconRightFill"
                              icon-before-modify="icon-fill icon_color_white"
                              modify="button_size_small"
                              @click="goToPage" />
            </div>
        </div>
    </div>
</template>

<script>
import IconCheckStatus from '@/components/Icons/CheckStatus';
import IconInfo from '@/components/Icons/Info';
import IconCloseSmall from '@/components/Icons/CloseSmall';

export default {
    name: 'InfoBlock',

    components: {
        IconCheckStatus,
        IconInfo,
        IconCloseSmall
    },

    props: {
        modify: [Array, Object, String],
        // Тип ошибки: 1 - инфо, 2 - ошибка
        type  : {
            type   : Number,
            default: 1
        },
        title: {
            type   : String,
            default: 'Что-то пошло не так'
        },
        description: {
            type   : String,
            default: 'По какой-то причине произошла сервисная ошибка, вернитесь назад к списку объектов.'
        },
        link: {
            type   : String,
            default: ''
        },
        linkText: {
            type   : String,
            default: 'К списку объектов'
        },
    },

    methods: {
        goToPage() {
            this.$router.push('/' + this.link);
        }
    }
};
</script>

<style lang="scss">
@import "InfoBlock";
</style>
